<template>
    <!-- Contenido con scroll -->
    <div class="content-scrollable">
        <v-form ref="form" v-model="valid" fast-fail @submit.prevent="handleSubmit">
            <v-row v-for="tipo in tiposDocumentacionLocal" :key="tipo.valor">
                <v-col cols="12">
                    <label class="my-text-black">{{tipo.nombre}}</label>
                </v-col>
                <v-col cols="12">
                    <ImageInput
                        :obligatorio="(autorizacionObligatoria && tipo.valor == 4 && !yaHayBonoCargado()) || (ordenYAltaComplejidadObligatoria && ((tipo.valor == 0 && !yaHayOrdenCargada()) || (tipo.valor == 5 && !yaHayPlanillaCargada())))"
                        v-model:imagenes="archivosPorTipo[tipo.valor]"
                        :maxImages="maxImagesPorTipo"
                    ></ImageInput>
                </v-col>
            </v-row>
        </v-form>
    </div>

    <!-- Botones fijos -->
    <div class="footer-fixed">
        <v-row>
            <v-col cols="12" md="8"></v-col>
            <v-col cols="12" md="2">
                <v-btn
                    text="Cancelar"
                    id="boton-verde"
                    @click="cancelarCarga"
                    :disabled="cargando"
                ></v-btn>
            </v-col>            
            <v-col cols="12" md="2">
                <v-btn
                    type="submit"
                    id="boton-verde"
                    text="Agregar"
                    :disabled="cargando || !valid || !hayArchivos"
                    :loading="cargando"
                    @click="handleSubmit"
                ></v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
.content-scrollable {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 24px 16px 24px;
}

.content-scrollable::-webkit-scrollbar {
    width: 8px;
}

.content-scrollable::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.content-scrollable::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.content-scrollable::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    background-color: white;
    padding: 16px 24px;
    border-top: 1px solid #e0e0e0;
    margin-top: 8px;
}
</style>

<style src="../assets/general.css"></style>

<script>
    /* eslint-disable */
    import ImageInput from "@/components/ImageInput.vue";
    import GeneralService from "@/api/GeneralService";

    const generalService = new GeneralService();

    export default {
        components:{
            ImageInput,
        },
        data: () => ({
            archivosPorTipo: [],
            todosLosArchivos: [],
            tiposDocumentacionLocal: [],
            valid: false,
            cargando: false,
        }),
        props: {
            autorizacionObligatoria: {
                type: Boolean,
                default: false,
            },
            ordenYAltaComplejidadObligatoria: {
                type: Boolean,
                default: false,
            },
            tiposDocumentacion: {
                type: Array,
                default: () => [],
            },
            archivosActuales: {
                type: Array,
                default: () => [],
            },
            maxImagesPorTipo: {
                type: Number,
                default: 20,
            },
        },
        computed: {
            hayArchivos() {
                // Verificar que al menos un tipo tenga archivos
                return this.archivosPorTipo.some(archivos => archivos && archivos.length > 0);
            }
        },
        async mounted(){
            this.cargando = true;
            if(this.tiposDocumentacion.length == 0){
                this.tiposDocumentacionLocal = await this.getTiposDocumentacion();
            } else {
                this.tiposDocumentacionLocal = this.tiposDocumentacion;
            }
            this.tiposDocumentacionLocal.forEach(tipo => {
                this.archivosPorTipo[tipo.valor] = [];
            });
            this.cargando = false;
        },
        methods: {
            async handleSubmit() {
                // Verificar que el formulario sea válido y haya archivos
                if (!this.valid || !this.hayArchivos || this.cargando) {
                    return;
                }
                
                this.cargando = true;
                
                try {
                    this.archivosPorTipo.forEach((array, index) => {
                        if (array) {
                            array.forEach(archivo => {
                                archivo.tipoDocumentacion = index;
                            });
                        }
                    });
                    
                    this.todosLosArchivos = Object.values(this.archivosPorTipo).flat();
                    this.$emit("agregarArchivos", this.todosLosArchivos);
                } finally {
                    // No desbloquear aquí, dejar que el padre cierre el modal
                    // this.cargando = false;
                }
            },
            async getTiposDocumentacion(){
                this.cargando = true;
                let tiposDocumentacionLocal = [];
                await generalService.GetTiposDocumentacion()
                    .then(response => {
                        tiposDocumentacionLocal = response.data;
                        tiposDocumentacionLocal.map(tipo => {
                            if (tipo.nombre == "BonoAdicional") {
                                tipo.nombre = "Autorización";
                            }
                        })
                    }) 
                    .catch(error => {
                        console.log(error);
                    });
                this.cargando = false;
                return tiposDocumentacionLocal;
            },
            cancelarCarga() {
                this.$emit("close");
            },
            yaHayBonoCargado(){
                return this.archivosActuales.some(archivo => archivo.tipoDocumentacion === 4);
            },
            yaHayOrdenCargada(){
                return this.archivosActuales.some(archivo => archivo.tipoDocumentacion === 0);
            },
            yaHayPlanillaCargada(){
                return this.archivosActuales.some(archivo => archivo.tipoDocumentacion === 5);
            }
        },
    }
</script>